import React from 'react';
import classNames from 'classnames';
import { Button, ButtonPriority as PRIORITY, Spinner } from 'wix-ui-tpa';
import styles from './load-more.scss';
import { classes } from './load-more.st.css';
import { SPINNER } from '../../../common/constants/data-hooks';
import TextExtended from '../text-extended/text-extended';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
const LoadMore = ({ text, onClick, className, isPending = false, dataHook, icon }) => {
    const { screenshotMode } = useConfiguration();
    return (React.createElement(Button, { className: classNames(classes.buttonRoot, styles.container, className), onClick: onClick && onClick, priority: PRIORITY.secondary, "data-hook": dataHook, upgrade: true },
        React.createElement(TextExtended, { typography: "button", priority: "buttonSecondary" }, text),
        icon ? icon : null,
        isPending ? (React.createElement(Spinner, { "data-hook": SPINNER, className: classNames(classes.spinnerRoot, styles.sufix), diameter: 17, isStatic: screenshotMode })) : (React.createElement("div", { className: styles.spinnerPlaceholder }))));
};
export default LoadMore;
//# sourceMappingURL=load-more.js.map